export const CONSTANTS = {
  CURRENCY_FORMAT: '1.2-2',
  DATE_FORMAT: 'dd-MMM-yyyy',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  DATE_TIME_12H: 'MM/DD/YYYY h:mm A',
  ISO_TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss',
  TIMEZONE_UTC: 'UTC',
  PDF_DATE_FORMAT: 'YYYY-MM-DD',
  pageSizeOptions: [25, 50, 100],
  CREATE_OPERATION: 'CREATE',
  CANCEL_OPERATION: 'CANCEL',
  CREDIT_STATUS_FULLY: 'FULLY_CREDITED',
  CREDIT_STATUS_PARTIAL: 'PARTIALLY_CREDITED',
  INVOICE_TYPE_CREDIT: 'CREDIT',
  INVOICE_TYPE_DEBIT: 'DEBIT',
  BE_DATE_FORMAT: 'YYYY-MM-DD',
  TABLE_NO_DATA: 'No data found',
  ACM_PARTIAL: 'ACM_PARTIAL',
  APP_TITLE: 'Faturti',
  UPDATE_CONFIRMED_INVOICE: 'UPDATE_CONFIRMED_INVOICE',
  allowedCodes: ['SAR', 'USD'],
};

export const ClIENT_COSTANTS = {
  CUSTOMER: 'CUSTOMER',
  BUSINESS: 'BUSINESS',
  INTERNATIONAL: 'INTERNATIONAL',
  GOVERNMENT: 'GOVERNMENT',
  SA: 'SA',
};

export const LOCAL_STORAGE_KEYS = {
  HOURLY_RATE_ARRAY: 'hourlyRateArray',
  FLIGHT_TIME_ARRAY: 'flightTimeArray',
  LAYOVER_TIME_ARRAY: 'layOverTimeArray',
  FLIGHT_MODULE_HOURLY_RATE_ARRAY: 'flightModuleHourlyRateArray',
  FLIGHT_MODULE_FLIGHT_TIME_ARRAY: 'flightModuleFlightTimeArray',
  FLIGHT_MODULE_LAYOVER_TIME_ARRAY: 'flightModuleLayOverTimeArray',
};

export const STATUS_COSTANTS = {
  DRAFTED: 'Drafted',
  CONFIRMED: 'Confirmed',
};

export const MODULE_PERMISSIONS: string[] = [
  'SALES_MODULE',
  'FINANCE_MODULE',
  'MEDVAC_MODULE',
  'MCC_MODULE',
  'GH_MODULE',
  'ESCORT_MODULE',
  'TRAINING_MODULE',
  'SALES_ORDER_MODULE',
  'ACM_MODULE',
  'FLIGHT_MODULE',
  'SALES_WORK_ORDER_MODULE',
  'AIRPORT_MANAGEMENT_SERVICE_MODULE',
  'ACMS_SALES_MODULE',
  'ACMS_SALES_WORK_ORDER_MODULE',
  'SALES_ORDER_FE',
];
